// extracted by mini-css-extract-plugin
var _1 = "Db3hemXaJWO0l5uymh_X";
var _2 = "BIuQgjzFmiE27haLpCgA";
var _3 = "FwOaEu43vVThAhcQYfSh";
var _4 = "g4GBvcEwe4nc98sEUzOz";
var _5 = "DESLoS95pPnMdb13x072";
var _6 = "j80XgFseKycWgH6yNwEq";
var _7 = "WxmzjUMU8VOShWDbpaqn";
var _8 = "s94loHyK3MJGX2A9FZfd";
var _9 = "gCxYpnlILicIBAG0ELZF";
export { _1 as "body", _2 as "label", _3 as "link", _4 as "link__help", _5 as "link_text", _6 as "notice", _7 as "root", _8 as "title", _9 as "wrapper" }
